module.exports = __webpack_public_path__ + "static/media/ghost.630b08d9.png";